var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 30C20 16.1929 24.4772 5 30 5C35.5227 5 40 16.1929 40 30C40 43.807 35.5227 55 30 55C24.4772 55 20 43.807 20 30Z",
    stroke: "#E0FFC5",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9382 21.548C37.0432 14.6445 49.1225 12.9253 51.9182 17.7083C54.7137 22.4912 47.1667 31.965 35.0617 38.8685C22.9567 45.772 10.8774 47.4912 8.08188 42.7082C5.28633 37.9252 12.8332 28.4515 24.9382 21.548Z",
    stroke: "#E0FFC5",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0617 21.548C47.1667 28.4515 54.7137 37.9252 51.9182 42.7082C49.1225 47.4912 37.0432 45.772 24.9382 38.8685C12.8332 31.965 5.28633 22.4912 8.08188 17.7083C10.8774 12.9253 22.9567 14.6445 35.0617 21.548Z",
    stroke: "#E0FFC5",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.75 30C33.75 32.071 32.071 33.75 30 33.75C27.929 33.75 26.25 32.071 26.25 30C26.25 27.929 27.929 26.25 30 26.25C32.071 26.25 33.75 27.929 33.75 30Z",
    stroke: "#E0FFC5",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReact);
export default __webpack_public_path__ + "static/media/react.e4510b309bc0bfa3e08b1e619032cce3.svg";
export { ForwardRef as ReactComponent };